export default __webpack_public_path__ + "static/media/sheet_thumb12_loancalculator@2x.3b780993.png";